import React from "react"
import NewUserPage from "../pages/NewUserPage"
import { UserRole } from "../types/user"
import { initReactApp } from "../utils/init"
import { getLocalLoan } from "../utils/loan";

const userRole: UserRole = document.location.pathname.indexOf("investors") !== -1 ? "investor" :
  getLocalLoan()?.loanType === "business" ? "business_borrower" : "borrower";
let backPath = userRole === "borrower" || userRole === "business_borrower" ? "../loans/new" : "";
backPath += document.location.search;

initReactApp(<NewUserPage backPath={backPath} userRole={userRole}/>);
